"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_BITLENGTH = void 0;
// Copyright 2017-2020 @polkadot/util authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
const DEFAULT_BITLENGTH = 32;
exports.DEFAULT_BITLENGTH = DEFAULT_BITLENGTH;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/util/compact/defaults.js
// module id = 158
// module chunks = 0